import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { TextareaField } from "../../shared/ui/textarea-field/textarea-field";
import { Button } from "../../shared/ui/button/button";
import { CustomDropdown } from "../../shared/components/custom-dropdown/custom-dropdown";
import { FileUpload } from "../../shared/components/file-upload/file-upload";
import { Sidebar } from '../../core/services/sidebar';
import { Popup } from '../../core/services/popup';

@Component({
  selector: 'app-help-center',
  imports: [
    TextareaField,
    TranslatePipe,
    Button,
    CustomDropdown,
    FileUpload,
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './help-center.html',
  styleUrl: './help-center.css'
})

export class HelpCenter {
  selected: 'none' | 'feedback' | 'complaint' = 'none';

  feedbackControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(250)]
  });

  complaintControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(250)]
  });

  maxLengthForTextArea = 250;

  complaintReasons = [
    {label: 'HELP_CENTER.SERVICE_QUALITY'},
    {label: 'HELP_CENTER.PRODUCT_AND_FEATURES'},
    {label: 'HELP_CENTER.COMPLAINT_RESOLUTION_TIME'},
    {label: 'HELP_CENTER.APPLICATION_ISSUES'},
    {label: 'HELP_CENTER.OTHER'}
  ];

  selectedReason: string | null = null;
  selectedFiles: File[] = [];

  constructor(
    private sidebarService: Sidebar,
    private popup: Popup,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.sidebarService.setLinks([
      {
        label: 'SIDEBAR.BACK_TO_SETTINGS',
        route: '/settings',
        iconPath: 'assets/icons/arrow-blue.svg',
        variant: 'outlined'
      }
    ]);
  }

  select(type: 'feedback' | 'complaint'): void {
    this.selected = type;
    
  if (type === 'feedback') {
    this.feedbackControl.reset('');
  } else {
    this.complaintControl.reset('');
  }
  }

  onReasonSelect(reason: any): void {
    this.selectedReason = reason.label;
  }

  onFilesChanged(files: File[]): void {
    this.selectedFiles = files
  }

  submitFeedback(): void {
    const message = this.feedbackControl.value.trim();

    if (this.feedbackControl.invalid || message.length === 0 || message.length > 250) {
      this.feedbackControl.markAsTouched();
      return;
    }

    const feedbackData = {
      message,
      files: this.selectedFiles
    };

    console.log('Feedback submitted:', feedbackData);

    this.popup.show({
      message: 'HELP_CENTER.FEEDBACK_SUBMITTED',
      type: 'success',
      duration: 3000,
      position: 'bottom',
      icon: 'assets/icons/check-popup.svg',
    });

    this.feedbackControl.reset();
    this.selectedFiles = [];
    this.router.navigate(['/settings']);
  }

  submitComplaint(): void {
    const message = this.complaintControl.value.trim();

    if (this.complaintControl.invalid || !this.selectedReason || message.length === 0) {
      this.complaintControl.markAsTouched();
      return;
    }

    const complaintData = {
      reason: this.selectedReason,
      message,
      files: this.selectedFiles
    };

    console.log('Complaint submitted:', complaintData);

    this.popup.show({
      message: 'HELP_CENTER.COMPLAINT_SUBMITTED',
      type: 'success',
      duration: 3000,
      position: 'bottom',
      icon: 'assets/icons/check-popup.svg',
    });

    this.complaintControl.reset();
    this.selectedFiles = [];
    this.selectedReason = null;
    this.router.navigate(['/settings']);
  }
}
